import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfigBased, WinConfigUtilBased} from "../../../utils/WinConfigUtil";
import {Outsourced} from "../../../Outsourced";
import {OutsourcedSound} from "../../../sound/OutsourcedSound";
import {ArrayUtils} from "../../../utils/ArrayUtils";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {OutsourcedSymbol} from "../../../reels/symbols/OutsourcedSymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


/**
 * Created by jonas on 2022-01-12.
 */

export class NormalWin implements SimplePresentation {

    name:string = "NormalWin";
    private controller:SimplePresentationRunnerController;
    private noWinSymbols:OutsourcedSymbol[];
    private winSymbols:OutsourcedSymbol[];

    constructor() {
    }

    shouldRun():boolean {
        return Outsourced.model.gameData.thisSpinWinnings > 0 &&
               Outsourced.model.wins.length > 0;
    }

    start(controller:SimplePresentationRunnerController):void {
        this.controller = controller;
        this.regularWin();
    }

    private setWinAndNoWinSymbols():void {
        this.winSymbols = Outsourced.model.getWinningPositions()
            .map((pos) => Outsourced.reelView.getSymbolAt(pos.reelID, pos.reelPosition));
        this.noWinSymbols = Outsourced.model.getNonWinningPositions()
            .map((pos) => Outsourced.reelView.getSymbolAt(pos.reelID, pos.reelPosition));
    }

    private blinkWinLines():gsap.core.Timeline {
        // win blink
        const wins = Outsourced.model.wins;
        const tl = gsap.timeline();
        wins.slice().sort((a,b) => b.winLineData.multipliedAmount - a.winLineData.multipliedAmount).forEach((win) => {
            const blinkTl = gsap.timeline();
            const blinkSymbols = win.winningPositions
                .map((pos) => Outsourced.reelView.getSymbolAt(pos.reelID, pos.reelPosition));

            const finalPosition = win.winningPositions[win.winningPositions.length - 1];
            blinkTl.add(() => {
                Outsourced.winView.showIndividualWin(win.winLineData.multipliedAmount,
                                                             win.winLineData.numberOfCombinations,
                                                             finalPosition.reelID,
                                                             finalPosition.reelPosition);
            });
            blinkTl.add(blinkSymbols.map((sym) => sym.getWinBlink()), '<');
            blinkTl.add(blinkSymbols.map((sym) => sym.setNormal()));
            tl.add(blinkTl);
            if (!(Outsourced.isWinBelowStake() && (Outsourced.model.data.mode == GameMode.NORMAL ||
                                                   Outsourced.model.data.mode == "RESPIN")))
                tl.add(() => Outsourced.soundPlayer.playSound("winHighlight"), '<');
        })
        tl.add(() => {}, '>0.15');
        return tl;
    }

    private playSymbolWins():gsap.core.Timeline[] {
        return this.winSymbols.reverse().map((sym) => sym.getWinAnimation());
    }

    private setNoWinSymbols() {
        return this.noWinSymbols.map((sym) => sym.setNoWin());
    }

    private moveUpWinningSymbols():gsap.Callback[] {
        return Outsourced.model.getWinningPositions().map((pos) => () => Outsourced.reelView.moveUpZ(pos.reelID, pos.reelPosition));
    }

    private moveDownWinningSymbols():gsap.Callback[] {
        return Outsourced.model.getWinningPositions().map((pos) => () => Outsourced.reelView.moveDownZ(pos.reelID, pos.reelPosition));
    }

    private regularWin():void  {
        const isQuickStop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const tl = gsap.timeline();
        this.setWinAndNoWinSymbols();

        if (isQuickStop)
           tl.add(() => {tl.timeScale(1.5)});

        tl.add(() => {
            this.controller.setSkipCallback(() => {tl.progress(1, false)})
        })

        tl.add(this.setNoWinSymbols(), '>0.25');
        tl.add(this.blinkWinLines());
        tl.add(this.playSymbolWins());
        tl.add(this.moveUpWinningSymbols(), '<');

        if (isQuickStop)
            tl.add(() => {tl.timeScale(1)});

        tl.add(() => Outsourced.soundPlayer.playSound("winStart"), isQuickStop ? '<-1' : '<');

        tl.add(this.noWinSymbols.map((sym) => sym.setNormal()));
        tl.add(this.moveDownWinningSymbols());
        tl.add(() => {
            this.controller.setSkipCallback();
            this.controller.finish()
        });
    }
}